import { ButtonAttributes, notes, Props } from "./types";
import Grid from "@mui/material/Grid";
import { Item, Root, styles } from "./styles";
import { MidiNote } from "../../reactronica";
import { useResizable } from "./useResizable";
import * as Tone from "tone";
import {
  DEFAULT_NOTE_DURATION,
  StepType,
} from "../../reactronica/components/Track";

export const COLUMNS = 16;

const PianoRoll: React.FC<Props> = ({
  currentStepIndex,
  steps,
  onClick,
  instrument,
}) => {
  const { height, handleMouseDown } = useResizable();

  const playNote = (note: MidiNote) => {
    switch (instrument) {
      case "amSynth": {
        const s1 = new Tone.AMSynth().toDestination();
        s1.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
        break;
      }
      case "duoSynth": {
        const s2 = new Tone.DuoSynth().toDestination();
        s2.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
        break;
      }
      case "fmSynth": {
        const s3 = new Tone.FMSynth().toDestination();
        s3.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
        break;
      }
      case "membraneSynth": {
        const s4 = new Tone.MembraneSynth().toDestination();
        s4.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
        break;
      }
      case "metalSynth": {
        const s5 = new Tone.MetalSynth().toDestination();
        s5.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
        break;
      }
      case "monoSynth": {
        const s6 = new Tone.MonoSynth().toDestination();
        s6.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
        break;
      }
         case "pluckSynth": {
        const s8 = new Tone.PluckSynth().toDestination();
        s8.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
        break;
      }
      case "synth": {
        const s9 = new Tone.Synth().toDestination();
        s9.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
        break;
      }
      case "sampler": {
        const s10 = new Tone.Sampler({
          urls: {
            B5: "/Sounds/snare1.mp3",
            G5: "/Sounds/kick2.mp3",
            A5: "/Sounds/kick1.mp3",
            F5: "/Sounds/clap1.wav",
            E5: "/Sounds/hi1.wav",
            D5: "/Sounds/perc1.wav",
          },
          onload: () => {
            s10.triggerAttackRelease(note, DEFAULT_NOTE_DURATION);
          },
        }).toDestination();
        break;
      }
    }
  };

  const truncateLastEmptyArrays = (a: StepType[]) => {
    let copy = [...a];
    while (((copy.at(-1) ?? []) as MidiNote[]).length === 0) {
      copy = copy.slice(0, -1);
      if (copy.length === 0) break;
    }
    return copy;
  };

  const onButtonClick = (column: number, note: MidiNote) => {
    let copy = [...steps];
    if (copy.length <= column) {
      const numberOfEmptyArraysToAppend = column - copy.length + 1;
      const arrayOfEmptyColumns = Array.from(
        Array(numberOfEmptyArraysToAppend).keys(),
        (c) => []
      );
      copy = copy.concat(arrayOfEmptyColumns);
    }
    let columnData: MidiNote[] | null =
      (copy[column] as MidiNote[] | null) ?? [];
    if (columnData.includes(note)) {
      columnData = columnData.filter((n) => n !== note);
    } else {
      columnData.push(note);
      playNote(note);
    }
    copy[column] = columnData;
    copy = truncateLastEmptyArrays(copy);
    onClick(copy);
  };

  const buttons: ButtonAttributes[][] = Array.from(notes, (note) =>
    Array.from(Array(COLUMNS).keys(), (column) => ({ column, note }))
  );

  return (
    <>
      <Root height={height}>
        <div style={styles.dragger} onMouseDown={(e) => handleMouseDown(e)} />
        <Grid container spacing={0} columns={COLUMNS + 2}>
          <Grid item xs={COLUMNS / 8}>
            <Item onClick={() => {}} disabled />
          </Grid>
          {Array.from(Array(COLUMNS).keys()).map((i) => (
            <Grid key={i} item xs={1}>
              <Item
                onClick={() => {}}
                sx={{
                  backgroundColor:
                    currentStepIndex === i ? "#7e0afa" : "#202121",
                }}
              >
                {i + 1}
              </Item>
            </Grid>
          ))}
          {buttons
            .map((rows, i) =>
              [
                <Grid key={notes[i]?.toString() ?? "i"} item xs={COLUMNS / 8}>
                  <Item
                    onClick={() => {}}
                    isSharpNote={notes[i]?.toString()?.includes("#") ?? false}
                    disabled
                  >
                    {notes[i]?.toString() ?? ""}
                  </Item>
                </Grid>,
              ].concat(
                rows.map(({ column, note }) => (
                  <Grid key={`${note}${column}`} item xs={1}>
                    <Item
                      onClick={() => onButtonClick(column, note)}
                      itemClicked={(
                        steps[column] as MidiNote[] | null
                      )?.includes(note as MidiNote)}
                    />
                  </Grid>
                ))
              )
            )
            .flat()}
        </Grid>
      </Root>
    </>
  );
};

export default PianoRoll;
